module.exports = __webpack_public_path__ + "static/media/paper.58c0b953.jpg";